<template>
  <div style="text-align:center; margin-top:200px;">
    <img src="../assets/image/common/error403.png" style="width:237px;height:158px;" alt="">
    <div>
        <p style="font-family: SourceHanSansCN-Medium;font-weight: 500;font-size: 18px;color: #4F5D78;">权限错误！</p>
        <p style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #4F5D78;margin:8px 0 ">非常抱歉，您无权访问该页面!</p>
        <p style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #4F5D78;">页面将在
          <span style="color:#066EB7">{{count}}</span> 秒后回到首页</p>
    </div>
  </div>
</template>


<script>
import { onlineUrl } from '@/utils/config';

export default {
  data(){
    return {
      count:3,
      isShowTimeHeader:1,
      onlineUrl,

    }
  },
  methods:{
    getTime(){
      const EndTime = 3
      if(!this.timer){
        this.timer = setInterval(()=>{
          if(this.count >= 1 && this.count <= EndTime){
            this.count--
            if(this.count==0){
              window.open(this.onlineUrl,"_self")

            }
          }else{
            clearInterval(this.timer)
            this.timer = null
            this.isShowTimeHeader = 0
          }
        },1000)
      }
    }
  },
  created(){
    this.getTime()
  }
}
</script>

